
(function(){
  var track=document.querySelector('.zh-track');if(!track)return;
  var slides=track.children,n=slides.length,i=0,html='';
  var dots=document.querySelector('.zh-dots');
  for(var d=0;d<n;d++){html+='<button class="zh-dot'+(d===0?' on':'')+'" aria-label="Slide '+(d+1)+'"></button>';}
  if(dots)dots.innerHTML=html;
  function go(k){i=(k+n)%n;track.style.transform='translateX(-'+(i*100)+'%)';
    var ds=document.querySelectorAll('.zh-dot');for(var j=0;j<ds.length;j++)ds[j].classList.toggle('on',j===i);}
  document.querySelector('.zh-next').addEventListener('click',function(){go(i+1);reset();});
  document.querySelector('.zh-prev').addEventListener('click',function(){go(i-1);reset();});
  if(dots){dots.addEventListener('click',function(e){var t=e.target;if(t&&t.classList.contains('zh-dot')){var idx=[].indexOf.call(dots.children,t);go(idx);reset();}});}
  var x0=null;
  track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
  track.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40){go(i+(dx<0?1:-1));reset();}x0=null;},{passive:true});
  var timer=setInterval(function(){go(i+1);},5000);
  function reset(){clearInterval(timer);timer=setInterval(function(){go(i+1);},5000);}
})();
